export default __webpack_public_path__ + "static/media/salt2.a80d815b.png";